import { motion, useMotionValue } from "framer-motion";
import { useRef, useEffect } from "react";
import { FaInstagram } from "react-icons/fa";
import { Link } from "react-router-dom";

export default function TeamSlider({ dataTeam }) {

  const containerRef = useRef(null);
  const sliderRef = useRef(null);

  const x = useMotionValue(0);

  const loopData = [...dataTeam, ...dataTeam];

  useEffect(() => {

    const slider = sliderRef.current;

    const checkLoop = () => {
      const sliderWidth = slider.scrollWidth / 2;

      if (Math.abs(x.get()) >= sliderWidth) {
        x.set(0);
      }

      requestAnimationFrame(checkLoop);
    };

    checkLoop();

  }, []);

  return (
    <div
      ref={containerRef}
      className="w-full overflow-hidden"
    >
      <motion.div
        ref={sliderRef}
        className="flex gap-8 cursor-grab active:cursor-grabbing"
        style={{ x }}
        drag="x"
        dragElastic={0.05}
        animate={{ x: ["0%", "-50%"] }}
        transition={{
          repeat: Infinity,
          duration: 20,
          ease: "linear"
        }}
      >
        {loopData.map((team, index) => (
          <div
            key={index}
            className="min-w-[260px] md:min-w-[320px] lg:min-w-[350px] p-8 bg-slate-800/50 rounded-2xl border border-slate-700"
          >
            <div className="flex flex-col items-center text-center">
              <div className="relative group">
                <img
                  src={`${process.env.REACT_APP_BASE_URL}uploads/images/${team.photo}`}
                  alt={team.name}
                  className="h-[200px] w-[200px] lg:h-[300px] lg:w-[300px] rounded-full object-cover transition duration-300 group-hover:scale-105"
                />

                {/* Overlay Glass */}
                <div className="absolute inset-0 rounded-full bg-white/10 backdrop-blur-md opacity-0 group-hover:opacity-100 transition duration-300 flex items-center justify-center">
                  {team.link_qr ? (
                     <Link to={`/p/${team.link_qr}`} target="_blank">
                        <button className="px-4 py-2 bg-white/20 backdrop-blur-md text-white rounded-full border border-white/30 hover:bg-white/30 transition">
                          Lihat Profile
                        </button>
                      </Link>
                  ) : (
                    <a
                      href={`https://instagram.com/${team.ig}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="px-4 py-2 bg-white/20 backdrop-blur-md text-white rounded-full border border-white/30 hover:bg-white/30 transition"
                    >
                      Lihat Profile
                    </a>
                  )}
                 
                </div>
              </div>

              <div className="py-4">
                <h4 className="text-white text-xl font-semibold">
                  {team.name}
                </h4>

                <p className="text-gray-400 text-sm">
                  {team.division}
                </p>

                <p className="text-gray-400 text-sm">
                  <a
                    href={`https://instagram.com/${team.ig}`}
                    target="_blank"
                    className=""
                  >
                    <div className="flex justify-center items-center text-white gap-2 flex-row py-2">
                      <FaInstagram size={21}></FaInstagram> {team.ig}
                    </div>
                  </a>
                </p>
              </div>

            </div>
          </div>
        ))}
      </motion.div>
    </div>
  );
}